import React, { useRef } from "react";
import { Avatar, Box, Button, Checkbox, Container, Divider, FormControl, Grid, IconButton, MenuItem, Select, Typography, styled } from "@mui/material";
import { TextField } from '../../common/form/input';
import PhoneInput from '../../common/form/PhoneInput';
import { Label } from '../../common/form/TextInput';
import { Formik, Form as FormikForm } from 'formik';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import CountryCodes from '../../helper/countryCodes.json'
import { createChildAccountsApiCall, updateChildAccountDetailApiCall } from "./Action";
import { childAccountSchema } from "../../schema/vendorSchema";
import { getValueFromObjectByKeys, translate } from "../../helper";
import { connect, useSelector } from "react-redux";
import LocalStorage from "../../defined/localStorage";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ImageZoom from "../../common/image-zoom";
import { UserAction } from "../../redux/action";
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { Userpilot } from 'userpilot'

import 'react-image-crop/dist/ReactCrop.css';
import Modal from '@mui/material/Modal';
import ImageEditor from "../../common/ImageCropModal";
import CustomSpinner from "../../common/CustomSpinner";
import PageTitleHeader from '../../common/page-title-header';

const brand = JSON.parse(LocalStorage.getItem('branding'))

const CancelButton = styled(Button)(({ theme }) => ({
    'borderRadius': 'calc(var(--sp-md2)*0.943396)',
    'border': '1px solid #6B7280',
    'padding': 'calc(var(--sp-md2)*0.943396) 0',
    'width': '100%',
    'textAlign': 'center',
    'fontSize': 'calc(var(--fs-xs)*1.50943396)',
    'fontWeight': '700',
    'color': '#6B7280',
    'textTransform': 'uppercase',
    'cursor': 'pointer'
}));
const SaveButton = styled(Button)(({ disabled }) => {
    const whiteLabel = useSelector((state) => state?.User?.branding);

    return {
        borderRadius: "calc(var(--sp-md2)*0.943396)",
        boxShadow: "0px 4px 10px 0px #B9830940",
        padding: "calc(var(--sp-md2)*0.943396)",
        background: disabled
            ? "#B0B0B0"
            : `${whiteLabel?.web_button_color || brand?.web_button_color || "#F8B218"}`,
        color: "white",
        width: "100%",
        textAlign: "center",
        fontSize: "calc(var(--fs-xs)*1.50943396)",
        fontWeight: "700",
        textTransform: "uppercase",
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.5 : 1,
        "&:hover": {
            background: disabled
                ? "#B0B0B0"
                : `${whiteLabel?.web_button_color || brand?.web_button_color || "#F8B218"}`,
        },
    };
});

const IOSSwitch = styled((props) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
    width: "calc(var(--fs-hero)*1.03773585)",
    height: "calc(var(--fs-xl)*1.22641509)",
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: "calc(var(--sp-xxs)*0.471698)",
        transitionDuration: '200ms',
        '&.Mui-checked': {
            transform: 'translateX(calc(var(--sp-md2)*1.6509434))',
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: '#111827',
                opacity: 1,
                border: 0,
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.5,
            },
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: '#111827',
            border: 'calc(var(--sp-sm)) solid #fff',
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
            color: theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600],
        },
        '&.Mui-disabled + .MuiSwitch-track': {
            opacity: theme.palette.mode === 'light' ? 0.6 : 0.3,
        },
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: "calc(var(--fs-xl)*1.0377358)",
        height: "calc(var(--fs-xl)*1.0377358)",
    },
    '& .MuiSwitch-track': {
        borderRadius: "calc(var(--sp-md2)*1.22641509)",
        backgroundColor: theme.palette.mode === 'light' ? 'rgba(230, 230, 230, 1)' : '#39393D',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], { duration: 200 }),
    },
}));

const ChildAccountsDetailBase = (props) => {
    const {
        userInfo: { user },
        getVendorProfile,
        isNew,
        childAccount,
        currentMobileNumber,
        goBack,
        goChildAccounts,
        setChildAccount,
        goPaymentInfo,
        title = 'Location',
        showBackButton = false,
        selectedSubscription,
        isCreatingSubscription,
        goPrevious
    } = props;
    const [vendorData, setVendorData] = React.useState(null);

    React.useEffect(() => {
        document.title = 'Location';
    }, []);

    React.useEffect(() => {
        if (user?.vendor.id) {
            getData();
        }
    }, []);

    const getData = async () => {
        const resVendorProfile = await getVendorProfile(user?.vendor.id);
        const resData = getValueFromObjectByKeys(resVendorProfile, ['data']);
        setVendorData(resData);
    }
    return (
        <>

            {vendorData ?
                <Container 
                    maxWidth={false} 
                    style={{ margin: 'auto', width: '100%', marginTop: 'calc(var(--sp-md2)*1.886792)' }} 
                    sx={{
                        maxWidth: 'calc(var(--fs-hero)*28.301886)',
                        '@media (min-width: 2560px)': {
                            maxWidth: 'calc(var(--fs-hero)*37.7358)'
                        }
                    }}
                >
                    <Box className='vendornotesuser'>
                        <Grid container spacing={1} alignItems={'center'} marginBottom={'calc(var(--sp-md2)*1.60377358)'}>
                            <Grid item xs={12}>
                                <Box display={'flex'} alignItems={'center'}>
                                    {showBackButton && (
                                        <IconButton onClick={goBack} sx={{ mr: 1, ml: 'calc(var(--sp-md2)*-4.71698113)' }}>
                                            <ArrowBackIcon sx={{ fontSize: "calc(var(--fs-xl)*1.3207547)", color: '#1A5A78' }} />
                                        </IconButton>
                                    )}
                                    <PageTitleHeader title={translate('accountDetails')} showBar={false} />
                                </Box>
                            </Grid>
                        </Grid>

                        {
                            childAccount && (
                                <LocationForm
                                    initialValues={childAccount}
                                    vendorData={vendorData}
                                    currentMobileNumber={currentMobileNumber}
                                    isNew={isNew}
                                    goChildAccounts={goChildAccounts}
                                    setChildAccount={setChildAccount}
                                    goPaymentInfo={goPaymentInfo}
                                    title={title}
                                    isCreatingSubscription={isCreatingSubscription}
                                    goPrevious={goPrevious}
                                />
                            )
                        }
                    </Box>
                </Container>
                : 
                    <CustomSpinner fullPage />
            }

        </>
    );

}

const LocationForm = ({ initialValues, currentMobileNumber, isNew, goChildAccounts, setChildAccount, goPaymentInfo, title, vendorData, isCreatingSubscription, goPrevious }) => {
    const [isLogoEdited, setIsLogoEdited] = React.useState(false);
    const [isPhoneFocused, setIsPhoneFocused] = React.useState(false);

    const fileInputRef = useRef(null);
    const [isEditorOpen, setIsEditorOpen] = React.useState(false);
    const [logoImage, setLogoImage] = React.useState(null);
    const [copied, setCopied] = React.useState(false);
    const [isSaving, setIsSaving] = React.useState(false);
    const overlayLoading = isSaving || isCreatingSubscription;

    const formikRef = useRef();

    const handleSubmit = async (values, actions) => {
        try {
            setIsSaving(true);
            const formattedMobileNumber = values.country_code + '-' + values.mobile_number.replace(/\D/g, '');

            const formData = new FormData();
            let updatedValues = Object.keys(values).reduce((acc, curr) => {
                if (curr === 'country_code' || (curr === 'child_logo' && typeof values[curr] === 'string')) {
                    return acc;
                }
                acc[curr] = values[curr];
                return acc;
            }, {});
            formData.append('mobile_number', formattedMobileNumber);
            Object.keys(updatedValues).forEach((key) => {
                if (key !== 'mobile_number') {
                    formData.append(`${key}`, updatedValues[key]);
                }
            });

            if (isNew) {
                const newChildAccount = await createChildAccountsApiCall(formData, setIsSaving, () => {
                    Userpilot.track('Location Added', {
                        custom_domain: values.custom_domain,
                        manage_branding: values.manage_branding
                    });
                });
                setChildAccount(newChildAccount);
                if (typeof goPaymentInfo === 'function') {
                    goPaymentInfo(newChildAccount);
                } else if (typeof goChildAccounts === 'function') {
                    goChildAccounts();
                }
            } else {
                await updateChildAccountDetailApiCall(formData, initialValues.id, setIsSaving, () => { });
            }
        } catch (e) {
            console.error("Error updating:", e);
        }
    };


    const onFileUpload = (evt) => {
        const file = evt.target.files[0];
        setLogoImage(file);
        setIsEditorOpen(true)
    }

    const handleCloseEditor = () => {
        setIsEditorOpen(false)
        let input = document.getElementById('child_logo');
        if (input) {
            input.value = ''
        }
        fileInputRef.current.value = '';
        setLogoImage(null)
    }

    const handleCroppedImage = (img) => {
        let arr = img.split(',');
        let mime = arr[0].match(/:(.*?);/)[1];
        let bstr = atob(arr[1]);
        let n = bstr.length;
        let u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        let file = new File([u8arr], logoImage.name, { type: mime });
        formikRef.current.setFieldValue('child_logo', file);
        setIsLogoEdited(true);
        handleCloseEditor()
    }

    const handleCopyLink = (link) => {
        navigator.clipboard.writeText(link);
        setCopied(true);
        setTimeout(() => {
            setCopied(false);
        }, 500)
    }

    return (
        <>
            {overlayLoading && (
                <CustomSpinner fullPage />
            )}
            <Formik
                innerRef={formikRef}
                initialValues={{
                    "location_name": initialValues.location_name || "",
                    "location": initialValues.location || "",
                    "mobile_number": currentMobileNumber.phoneNumber || "",
                    "country_code": currentMobileNumber.countryCode || "",
                    "child_logo": initialValues.child_logo || "",
                    "custom_domain": initialValues.custom_domain || false,
                    "manage_branding": initialValues.manage_branding || false,
                    "admin_email_1": initialValues.admin_email_1 || "",
                    "admin_email_2": initialValues.admin_email_2 || "",
                    "admin_name_1": initialValues.admin_name_1 || "",
                    "admin_name_2": initialValues.admin_name_2 || "",
                    "tax_percentage": initialValues.tax_percentage ?? "",
                }}
                validationSchema={childAccountSchema}
                onSubmit={handleSubmit}
            >
                {({ isSubmitting, values, errors, touched, setFieldValue, handleChange }) => (
                    <FormikForm>
                        <FormControl fullWidth>
                            <Box style={{ display: 'flex', alignItems: 'flex-start', gap: 'calc(var(--sp-lg)*7.9245283)' }}>
                                <Box>
                                    <Box className='accountprofile'>
                                        <ImageZoom
                                            imageSrc={vendorData?.logo}
                                            altSrc={vendorData?.logo}
                                        >
                                            <Avatar
                                                variant="rounded"
                                                src={vendorData?.logo}
                                                sx={{
                                                    width: "calc(var(--fs-hero)*2.83018868)",
                                                    height: "calc(var(--fs-hero)*2.83018868)",
                                                    border: '1px solid white',
                                                    borderRadius: "var(--sp-xxs)",
                                                    '& .MuiAvatar-img': { objectFit: 'contain' }
                                                }}
                                            />
                                        </ImageZoom>
                                    </Box>
                                    <Box marginY={'calc(var(--sp-md2)*1.50943396)'}>
                                        <Typography fontSize={'calc(var(--fs-xs)*1.32075)'} fontWeight={400}>{translate('businessDescription')}</Typography>
                                        <Box className='accountdescription'>
                                            <Typography fontSize={'calc(var(--fs-xs)*1.32075)'} fontWeight={400}>{vendorData?.description || 'N/A'}</Typography>
                                        </Box>
                                    </Box>
                                </Box>
                                <Box style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                    <Typography fontSize={'calc(var(--fs-xs)*1.415094)'} fontWeight={500} marginBottom={'calc(var(--sp-xxs)*1.88679)'} color={'rgba(81, 83, 89, 1)'}>
                                        {translate('locationLogo')}
                                    </Typography>
                                    <Box className='accountprofile' style={{ display: 'flex', alignItems: 'center', gap: 'calc(var(--sp-md2)*1.509433)' }}>
                                        <ImageZoom
                                            imageSrc={values.child_logo && isLogoEdited ? URL.createObjectURL(values.child_logo) : (values.child_logo || '')}
                                            altSrc={values.child_logo && isLogoEdited ? URL.createObjectURL(values.child_logo) : (values.child_logo || '')}
                                        >
                                            <Avatar
                                                variant="rounded"
                                                src={
                                                    values.child_logo && isLogoEdited ? URL.createObjectURL(values.child_logo) : (values.child_logo || '')
                                                }
                                                sx={{
                                                    width: 'calc(var(--fs-hero)*2.83018868)',
                                                    height: 'calc(var(--fs-hero)*2.83018868)',
                                                    border: '1px solid white',
                                                    borderRadius: 'calc(var(--sp-xxs)*1.88679)',
                                                    '& .MuiAvatar-img': { objectFit: 'contain' }
                                                }}
                                            />
                                        </ImageZoom>
                                        <Button
                                            variant="outlined"
                                            startIcon={<FileUploadOutlinedIcon sx={{ fontSize: 'calc(var(--fs-xs)*1.88679) !important' }} />}
                                            className="upload-image-button"
                                            component="label"
                                            style={{ textTransform: 'none', cursor: 'pointer' }}
                                            sx={{ cursor: 'pointer', '& *': { cursor: 'pointer' }, fontSize: 'calc(var(--fs-xs)*1.32075)' }}
                                        >
                                            {translate('uploadImage')}
                                            <input
                                                type='file'
                                                hidden
                                                name='child_logo'
                                                id='child_logo'
                                                ref={fileInputRef}
                                                onChange={onFileUpload}
                                            />
                                        </Button>
                                    </Box>
                                </Box>
                            </Box>
                        </FormControl>
                        
                        <Box sx={{ display: 'flex', gap: 'calc(var(--sp-md2)*1.8867924)', marginTop: 'calc(var(--sp-lg)*1.132075)' }}>
                            <Box sx={{ flex: 1 }}>
                                <TextField
                                    label={translate('locationName')}
                                    value={values.location_name}
                                    type='text'
                                    id='location_name'
                                    name='location_name'
                                    error={Boolean(touched.location_name && errors.location_name)}
                                    helperText={touched.location_name && errors.location_name}
                                    fullWidth
                                    variant='outlined'
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            padding: 0,
                                            boxSizing: 'border-box',
                                            display: 'flex',
                                            alignItems: 'center',
                                            '& fieldset': { top: 0 },
                                            '& .MuiOutlinedInput-input': {
                                                padding: '0 calc(var(--sp-md2)*1.132075)',
                                                height: '100%',
                                                lineHeight: 'var(--fs-hero)',
                                            }
                                        },
                                    }}
                                    style={{ height: 44 }}
                                />
                            </Box>
                            <Box sx={{ flex: 1 }}>
                                <TextField
                                    label={translate('locationAddress')}
                                    value={values.location}
                                    type='text'
                                    id='location'
                                    name='location'
                                    error={Boolean(touched.location && errors.location)}
                                    helperText={touched.location && errors.location}
                                    fullWidth
                                    variant='outlined'
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            backgroundColor: '#fff',
                                            padding: 0,
                                            boxSizing: 'border-box',
                                            display: 'flex',
                                            alignItems: 'center',
                                            '& fieldset': { top: 0 },
                                            '& .MuiOutlinedInput-input': {
                                                padding: '0 calc(var(--sp-md2)*1.132075)',
                                                height: '100%',
                                                lineHeight: 'var(--fs-hero)'
                                            }
                                        },
                                    }}
                                    style={{ height: 44 }}
                                />
                            </Box>
                            <Box sx={{ flex: 1 }}>
                                <Label htmlFor={'phone_number'}>{translate('locationPhoneNumber')}</Label>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'stretch',
                                        backgroundColor: '#fff',
                                        height: 'calc(var(--fs-hero)*1.157894)',
                                        border: '1px solid',
                                        borderColor: (touched.mobile_number && errors.mobile_number) || (touched.country_code && errors.country_code) ? 'error.main' : isPhoneFocused ? '#1976d2' : '#D0D5DD',
                                        borderRadius: 'calc(var(--sp-xxs)*1.88679)',
                                        overflow: 'hidden',
                                        '&:focus-within': {
                                            borderColor: '#1976d2'
                                        }
                                    }}
                                >
                                    <FormControl
                                        sx={{
                                            height: '100%',
                                            minWidth: 'calc(var(--fs-hero)*2.2)',
                                            '@media (min-width: 2560px)': {
                                                minWidth: 'calc(var(--fs-hero)*2.5)'
                                            },
                                            background: 'transparent',
                                            '& .MuiInputBase-root': {
                                                height: '100%',
                                                background: 'transparent',
                                                borderRadius: 0
                                            },
                                            '& .MuiSelect-select': {
                                                display: 'flex',
                                                alignItems: 'center',
                                                height: 'calc(var(--fs-hero)*1.157894)',
                                                padding: '0 calc(var(--sp-md2)*1.132075)',
                                                background: 'transparent',
                                                lineHeight: 'calc(var(--fs-hero)*1.157894)',
                                            },
                                            '& .MuiSelect-icon': {
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                width: 'calc(var(--fs-xs)*2.07547)',
                                                height: 'calc(var(--fs-xs)*2.07547)',
                                            },
                                            '& fieldset': { display: 'none' },
                                            '&:hover': { background: 'transparent' }
                                        }}
                                    >
                                        <Select
                                            variant='standard'
                                            disableUnderline
                                            displayEmpty
                                            onChange={handleChange}
                                            onFocus={() => setIsPhoneFocused(true)}
                                            onBlur={() => setIsPhoneFocused(false)}
                                            value={values.country_code}
                                            id='country_code'
                                            name='country_code'
                                            renderValue={
                                                values.country_code !== ''
                                                    ? () => {
                                                        const { code, dial_code } = CountryCodes.find(cc => cc.dial_code === values.country_code) || {}
                                                        return (
                                                            <span style={{
                                                                fontSize: 'calc(var(--fs-xs)*1.509433)',
                                                            }}>{code + ' ' + dial_code}</span>
                                                        )
                                                    }
                                                    : () => <span style={{ color: '#ababab', fontSize: 'calc(var(--fs-xs)*1.509433)'}}>{''}</span>
                                            }
                                        >
                                            {
                                                CountryCodes.map((option, index) => (
                                                    <MenuItem sx={{ fontSize: 'calc(var(--fs-xs)*1.578947)' }} key={`${option.dial_code}-${index}`} value={option.dial_code}>{option.code + ' ' + option.dial_code}</MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>
                                    <Box sx={{ width: '1px', background: '#E5E7EB', alignSelf: 'stretch' }} />
                                    <Box sx={{ flex: 1, height: '100%', display:'flex', alignItems:'center' }}>
                                        <PhoneInput
                                            name='mobile_number'
                                            value={values.mobile_number}
                                            onChange={handleChange}
                                            style={{
                                                padding: '0 calc(var(--sp-md2)*1.132075)',
                                                height: 'calc(var(--fs-hero)*1.157894)',
                                                lineHeight: 'calc(var(--fs-hero)*1.0377)',
                                                fontSize: 'calc(var(--fs-xs)*1.6)',
                                                background: 'transparent',
                                                border: 'none',
                                                outline: 'none',
                                                width: '100%'
                                            }}
                                        />
                                    </Box>
                                </Box>
                                {(touched.mobile_number && errors.mobile_number) && (
                                    <Typography color='error' fontSize={'calc(var(--fs-xs)*1.132075)'} marginTop={'calc(var(--sp-xxs)*1)'}>{errors.mobile_number}</Typography>
                                )}
                            </Box>
                        </Box>

                        {/* Divider */}
                        <Box sx={{ marginY: 'calc(var(--sp-lg)*1.132075)' }}>
                            <Divider />
                        </Box>

                        {/* Admin Section */}
                        <Typography fontSize={'calc(var(--fs-xs)*1.698113)'} fontWeight={'600'} textAlign={'start'}>
                            {translate('admin')}
                        </Typography>

                        {/* Admin Fields Row */}
                        <Box sx={{ display: 'flex', gap: 'calc(var(--sp-md2)*1.8867924)', marginTop: 'calc(var(--sp-lg)*1.132075)' }}>
                            <Box sx={{ flex: 1 }}>
                                <TextField
                                    label={translate('name')}
                                    value={values.admin_name_1}
                                    type='text'
                                    id='admin_name_1'
                                    name='admin_name_1'
                                    error={Boolean(touched.admin_name_1 && errors.admin_name_1)}
                                    helperText={touched.admin_name_1 && errors.admin_name_1}
                                    fullWidth
                                    variant='outlined'
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            backgroundColor: '#fff',
                                            padding: 0,
                                            boxSizing: 'border-box',
                                            display: 'flex',
                                            alignItems: 'center',
                                            '& fieldset': { top: 0 },
                                            '& .MuiOutlinedInput-input': {
                                                padding: '0 calc(var(--sp-md2)*1.132075)',
                                                height: '100%',
                                                lineHeight: 'var(--fs-hero)'
                                            }
                                        }
                                    }}
                                    style={{ height: 44 }}
                                />
                            </Box>
                            <Box sx={{ flex: 1 }}>
                                <TextField
                                    label={translate('email')}
                                    value={values.admin_email_1}
                                    type='text'
                                    id='admin_email_1'
                                    name='admin_email_1'
                                    disabled={!isNew}
                                    error={Boolean(touched.admin_email_1 && errors.admin_email_1)}
                                    helperText={touched.admin_email_1 && errors.admin_email_1}
                                    fullWidth
                                    variant='outlined'
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            backgroundColor: '#fff',
                                            padding: 0,
                                            boxSizing: 'border-box',
                                            display: 'flex',
                                            alignItems: 'center',
                                            '& fieldset': { top: 0 },
                                            '& .MuiOutlinedInput-input': {
                                                padding: '0 calc(var(--sp-md2)*1.132075)',
                                                height: '100%',
                                                lineHeight: 'var(--fs-hero)'
                                            }
                                        }
                                    }}
                                    style={{ height: 44 }}
                                />
                            </Box>
                            <Box sx={{ flex: 1 }}>
                                <Box sx={{ minHeight: 'calc(var(--fs-hero)*2)' }}><TextField
                                    label={translate('taxPercentage')}
                                    value={values.tax_percentage}
                                    type='number'
                                    id='tax_percentage'
                                    name='tax_percentage'
                                    error={Boolean(touched.tax_percentage && errors.tax_percentage)}
                                    helperText={touched.tax_percentage && errors.tax_percentage}
                                    fullWidth
                                    variant='outlined'
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            backgroundColor: '#fff',
                                            padding: 0,
                                            boxSizing: 'border-box',
                                            display: 'flex',
                                            alignItems: 'center',
                                            '& fieldset': { top: 0 },
                                            '& .MuiOutlinedInput-input': {
                                                padding: '0 calc(var(--sp-md2)*1.132075)',
                                                height: '100%',
                                                lineHeight: 'var(--fs-hero)'
                                            }
                                        }
                                    }}
                                    style={{ height: 44 }}
                                /></Box>
                            </Box>
                        </Box>


                        <Typography fontSize={'calc(var(--fs-xs)*1.698113)'} fontWeight={'600'} textAlign={'start'} marginTop={'calc(var(--sp-md2)*1.4150943)'}>
                            {translate('accessPermissions')}
                        </Typography>

                        <Box display={'flex'} alignItems={'center'} gap={'calc(var(--sp-lg)*1.886792)'} marginTop={'calc(var(--sp-md2)*1.4150943)'}>
                            <FormControlLabel
                                label={translate('manageBranding')}
                                labelPlacement="start"
                                sx={{ marginLeft: 0, gap: 'calc(var(--sp-md2)*1.132075)', '& .MuiFormControlLabel-label': { fontWeight: 500, fontSize: 'calc(var(--fs-xs)*1.509433) !important', color: '#6A6A89 !important' } }}
                                control={<IOSSwitch checked={values.manage_branding} onChange={(evt) => setFieldValue('manage_branding', evt.target.checked)} />}
                            />
                            <FormControlLabel
                                label={translate('customDomain')}
                                labelPlacement="start"
                                sx={{ marginLeft: 0, gap: 'calc(var(--sp-md2)*1.132075)', '& .MuiFormControlLabel-label': { fontWeight: 500, fontSize: 'calc(var(--fs-xs)*1.509433) !important', color: '#6A6A89 !important' } }}
                                control={<IOSSwitch checked={values.custom_domain} onChange={(evt) => setFieldValue('custom_domain', evt.target.checked)} />}
                            />
                        </Box>

                        {title !== '' && (<Box marginY={'calc(var(--sp-md2)*1.886792)'}>
                            <FormControlLabel
                                label={
                                    <p>
                                        {translate('setupStatement')}&nbsp; or&nbsp;
                                        {initialValues.setup_link && <Typography
                                            style={{ width: 'fit-content', cursor: 'pointer' }}
                                            component={'a'}
                                            onClick={() => handleCopyLink(initialValues.setup_link)}
                                            color={'#4CCAF2'}>
                                            {translate('copyLink')}
                                            {
                                                copied ? <CheckBoxIcon style={{ color: "green", fontSize: "calc(var(--fs-xs)*1.415094)" }} /> : <></>
                                            }
                                        </Typography>
                                        }
                                    </p>
                                }
                                labelPlacement="end"
                                control={<Checkbox checked={true} style={{ color: '#F8B218', padding: 'calc(var(--sp-xs)) calc(var(--sp-md2)*1.415094) calc(var(--sp-xs)) 0px' }} />}
                            />
                        </Box>)}
                        <Box display={'flex'} justifyContent={isNew ? 'space-between' : 'flex-end'} alignItems={'center'} marginY={'calc(var(--sp-md2)*1.886792)'} gap="calc(var(--sp-md2)*1)">
                            <CancelButton onClick={goChildAccounts} style={{ width: 'auto', minWidth: 'calc(var(--fs-hero)*2.83018868)' }}>
                                {translate("cancel")}
                            </CancelButton>
                            {isNew ? (
                                <Box display={'flex'} gap={'calc(var(--sp-md2)*1)'}>
                                    <CancelButton onClick={goPrevious} style={{ width: 'auto', minWidth: 'calc(var(--fs-hero)*2.83018868)' }}>
                                        {translate("previous")}
                                    </CancelButton>
                                    <SaveButton type="submit" disabled={isSaving || isCreatingSubscription} style={{ width: 'auto', minWidth: 'calc(var(--fs-hero)*2.83018868)' }}>
                                        {isSaving || isCreatingSubscription ? translate("saving") : translate("submit")}
                                    </SaveButton>
                                </Box>
                            ) : (
                                <SaveButton type="submit" disabled={isSaving || isCreatingSubscription} style={{ width: 'auto', minWidth: 'calc(var(--fs-hero)*2.83018868)' }}>
                                    {isSaving || isCreatingSubscription ? translate("saving") : translate("submit")}
                                </SaveButton>
                            )}
                        </Box>
                    </FormikForm>
                )}

            </Formik>

            <Modal open={isEditorOpen} onClose={handleCloseEditor}>
                <div style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div style={{ width: "60%", minHeight: "calc(var(--fs-hero)*9.43396)", position: "relative", background: "#000", padding: "calc(var(--sp-md2)*1)" }}>
                        <ImageEditor img={logoImage} setCroppedImage={handleCroppedImage} handleCloseEditor={handleCloseEditor} />
                    </div>
                </div>
            </Modal>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        userInfo: getValueFromObjectByKeys(state, ['User', 'userInfo']),
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getVendorProfile: (id) => {
            return dispatch(UserAction.getVendorProfile(id));
        },
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(ChildAccountsDetailBase);